
        import { Mapper } from "../../../../base/utils/mapper";
import { MuscleEvaluationPhysiotherapyResponseModel } from "../../../../domain/models/consult/muscle-evaluation-physiotherapy-response.model";
import { MuscleEvaluationPhysiotherapyResponseEntity } from "../entities/muscle-evaluation-physiotherapy-response.entity";

        export class MuscleEvaluationPhysiotherapyImplementationRepositoryMapper extends Mapper<MuscleEvaluationPhysiotherapyResponseEntity, MuscleEvaluationPhysiotherapyResponseModel>{
            mapFrom(param:  MuscleEvaluationPhysiotherapyResponseEntity):  MuscleEvaluationPhysiotherapyResponseModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  MuscleEvaluationPhysiotherapyResponseModel):  MuscleEvaluationPhysiotherapyResponseEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }